import { render, staticRenderFns } from "./SuggestionListTable.vue?vue&type=template&id=a32ebfe2&scoped=true&"
import script from "./SuggestionListTable.vue?vue&type=script&lang=js&"
export * from "./SuggestionListTable.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionListTable.vue?vue&type=style&index=0&id=a32ebfe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32ebfe2",
  null
  
)

export default component.exports